module.exports = __webpack_public_path__ + "media/lobby_selfintro.d533c7c1.mp3";